/*
 * Scroll to top controller.
 */
var ScrollController = (function ($) {

    var win, doc, body, topLink, timer, topLinkContainer;

    function ready() {
        win = $(window);
        doc = $(document.body);
        body = doc;

        // Don't bother with "Back to top" if this is a mobile device.
        if (!BreakpointController.isMobile()) {

            topLinkContainer = $("<nav aria-label='Back to top'></nav>");
            topLink = $("<a href='#' class='back-to-top'><span aria-hidden='true' class='icon-chevron-up'></span>Top</a>");
            topLinkContainer.prepend(topLink);
            body.append(topLinkContainer);

            topLink.on('click', onBackToTopClick);

            checkLinkVisibility();
            win.on('scroll', checkLinkVisibilityTimeout);
        }

        // If links are marked with a data-scroll-to selector, use the scrollTo function's animation to perform the scrolling so it looks nice.
        doc.on('click', 'a[data-scroll-to]', onScrollToClick);
    }

    // On click of a data-scroll-to element use the scrollTo method to navigate to the item.
    function onScrollToClick(e) {
        var element = $(e.target),
            scrollToElement = $(element.attr('data-scroll-to'));

        if (!scrollToElement || scrollToElement.length === 0) return;

        e.preventDefault();
        scrollTo(scrollToElement, BreakpointController.isMobile());
    }

    // When the link is clicked, head back to the top of the page.
    function onBackToTopClick(e) {
        e.preventDefault();
        scrollTo();
    }

    // Scroll to the top of the page.
    function scrollTo(element, fudgeHeaderHeight, callback) {
        if (typeof callback !== 'function') {
            callback = function () { };
        }
        element = $(element);
        fudgeHeaderHeight = !!fudgeHeaderHeight;
        var position = (element && element.length > 0) ? element.offset().top : 0;
        if (fudgeHeaderHeight) {
            position -= $("#root header").outerHeight();
            if (position < 0) {
                position = 0;
            }
        }
        $('html, body').animate({ scrollTop: position }, 400, 'easeInOutExpo', callback);
    }

    // Check whether or not the Back to Top link should be visible or not.
    function checkLinkVisibility() {
        if (win.scrollTop() >= win.height() * 0.33333333333) {
            showTopLink();
        }
        else {
            hideTopLink();
        }
    }

    function checkLinkVisibilityTimeout() {
        clearTimeout(timer);
        timer = setTimeout(function () {
            checkLinkVisibility();
        }, 14);
    }

    function showTopLink() {
        if (topLink.is(":visible")) return;
        topLink.css({ right: -topLink.outerWidth() + 'px', display: "block" });
        topLink.stop(true, false).animate({ right: 0 }, 250, 'easeInOutExpo');
    }

    function hideTopLink(quick) {
        if (!topLink.is(":visible") || topLink.hasClass('ux-closing')) return;

        topLink.addClass('ux-closing');

        topLink.stop(true, false).animate({ right: -topLink.outerWidth() + 'px' }, 250, 'easeInOutExpo', function () {
            topLink.attr('style', '');
            topLink.removeClass('ux-closing');
        });
    }

    $(ready);

    return {
        scrollTo: scrollTo,
        showTopLink: showTopLink,
        hideTopLink: hideTopLink
    };

})(jQuery);